import config from '@/config/index';
import { request } from './api';
import queryParams from '../services/pageQuery.service';
const appId = 'dealer.vr';
const urls = {
  getTokenInfo: '/api/audiocall/token/v1/access-token',
  getSalerInfo: '/api/audiocall/session/v1/userinfo/query',
  stateUpdate: '/api/audiocall/session/v1/update',
  heartbeat: '/api/audiocall/session/v1/heartbeat',
  sales: '/api/audiocall/session/v1/userinfo/sales',
  userQueryVr: '/api/sales/reception/first/user/query',
  getList: '/dealer/v1/list',
  hasIM: '/api/sales/im/rights',
  vrSaleSetting: '/api/sale/setting',
  hasCountForUser: '/api/show/room/v1/visit/status',
  salerStatusSetting: '/api/show/room/v1/reception/status/setting',
  getServiceAdvisor: '/api/show/room/v1/visit/report',
  getSalesById: '/api/sales/getVisitReportSaleInfo', // '/api/sales/getSaleInfo'
};
function transformResponse(data) {
  if (data) {
    return { returncode: 0, message: '', result: data };
  } else {
    return { returncode: 1, message: '', result: data };
  }
}
export default {
  // 备注： 后端小伙伴告知：{version} =>写死 => v1

  /**
   *  获取token等信息
   *  接口地址wike：http://wiki.corpautohome.com/pages/viewpage.action?pageId=195389050
   *               http://doc.phonebus.corpautohome.com/project/900/interface/api/27341
   *  dealerId：供应商ID
   *  role：用户角色：1-通话发起者（C端）；2-通话接收者（B端）
   *  timestamp：时间戳
   */
  getTokenInfo(params) {
    const {
      dealerId,
      role,
      timestamp,
      source,
      traceId,
      ext,
      salesId,
      deviceId,
      seriesId,
    } = params;
    const floor = queryParams.floor;
    return request({
      type: 'post',
      xhrFields: { withCredentials: true },
      url:
        config.vrtake +
        urls.getTokenInfo +
        '?appId=' +
        appId +
        '&traceId=' +
        traceId,
      data: JSON.stringify({
        _appId: appId,
        dealerId,
        salesId,
        role,
        timestamp,
        // jumpUrl: `http://local.dealer.m.autohome.com.cn/vr/${dealerId}/dealerm/index.html?realtimeanswer=1&pvareaid=6852202&deviceId=${deviceId}&seriesId=${seriesId}`,
        jumpUrl: `${config.baseDomain}/vr/${dealerId}/dealerm/index.html?realtimeanswer=1&pvareaid=6852202&deviceId=${deviceId}&seriesId=${seriesId}&floor=${floor}`,
        ext: {
          traceId,
          positionId: source,
          ...ext,
        },
      }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   *  语音通话之前，获取到对方（顾问）信息
   *  接口地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=195389979
   *  channelName：频道名称
   *  role：用户角色：1-通话发起者（C端）；2-通话接收者（B端）
   */
  getSalerInfo(params) {
    const { channelName, role } = params;
    const url = config.vrtake + urls.getSalerInfo;
    return request({
      type: 'get',
      url,
      data: {
        _appId: appId,
        role,
        channelName,
      },
      transformResponse,
    });
  },

  /**
   *  通话状态发生变化是，要上报给服务器（目前声网中使用）
   *  接口wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=195386608
   *  state：当前通话状态
   *  channelName：频道名称
   *  role：用户角色：1-通话发起者（C端）；2-通话接收者（B端）
   */
  stateUpdate(params) {
    const { state, channelName, role } = params;
    return request({
      type: 'post',
      url: config.vrtake + urls.stateUpdate + '?appId=' + appId,
      data: JSON.stringify({ state, channelName, role }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },

  /**
   *  心跳维持接口：给C端、顾问端提供通话期间，心跳监测接口，近乎实时感知会话状态
   *  接口wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=195389968
   *  channelName：频道名称
   *  role：用户角色：1-通话发起者（C端）；2-通话接收者（B端）
   */
  heartBeatListen(params) {
    const { channelName, role } = params;
    const url = config.vrtake + urls.heartbeat;
    return request({
      type: 'get',
      dataType: 'json',
      url,
      data: {
        _appId: appId,
        role,
        channelName,
      },
      transformResponse,
    });
  },
  /**
   *  顾问用户信息获取
   *  接口wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=198177315
   *  Ypi地址：http://doc.phonebus.corpautohome.com/project/900/interface/api/25424
   *   _appId: app平台app.android , app.ios
   *  encryptedInfo: 顾问信息加密串
   *  role: 用户角色：1-通话发起者（C端）；2-通话接收者（B端）
   */
  getUserInfo(params) {
    const { encryptedInfo } = params;
    const url = config.vrtake + urls.sales + '?appId=' + appId;
    return request({
      type: 'post',
      url,
      data: JSON.stringify({
        _appId: appId,
        encryptedInfo,
      }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * 顾问VR优先接待信息查询
   * 调用方：主App端
   * 接口wiki地址：http://wiki.corpautohome.com/pages/viewpage.action?pageId=204383584
   * _appId  业务方名称
   * dealerId 经销商id
   * saleId 顾问id
   */
  userQueryVr(params) {
    const { dealerId, userId } = params;
    return request({
      type: 'get',
      url: config.vrtake + urls.userQueryVr,
      data: {
        dealerId,
        _appId: appId,
        userId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },

  /**
   * 顾问登录进入vr看车，选择店铺用的列表
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/21277
   * appId  业务方名称
   * dealerIds 经销商id,多个用逗号分割
   */

  getList(params) {
    const { dealerIds } = params;
    return request({
      type: 'get',
      url: config.dealerCloudArVr + urls.getList,
      data: {
        dealerIds,
        appId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * 验证顾问是否有IM权益
   * wiki地址http://wiki.corpautohome.com/pages/viewpage.action?pageId=204400101
   * _appId  业务方名称
   * dealerIds 经销商id,多个用逗号分割
   * encryptedInfo 销售加密串
   */
  getSalerImLink(params) {
    const { dealerId, encryptedInfo } = params;
    return request({
      type: 'get',
      url: config.vrtake + urls.hasIM,
      data: {
        dealerId,
        encryptedInfo,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/22345
   * c端访问状态查询接口
   * _appId 应用标识
   * dealerId 经销商id
   * version 接口版本
   */
  hasCountForUser(params) {
    const { dealerId } = params;
    return request({
      type: 'get',
      url: config.vrtake + urls.hasCountForUser,
      data: {
        dealerId,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/22351
   * _appId 应用标识(String)
   * dealerId 经销商id
   * saleId  顾问加密串，saleId，encryption二选一传递(暂时没用)
   * encryption 顾问加密串，saleId，encryption二选一传递
   * timestamp 接口请求时间戳，单位毫秒
   */
  salerStatusSetting(params) {
    const { dealerId, encryption } = params;
    return request({
      type: 'POST',
      url: config.vrtake + urls.salerStatusSetting + '?_appid=' + appId,
      data: JSON.stringify({
        // _appid: appId,
        dealerId,
        encryption,
        timestamp: new Date().getTime(),
      }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * c端访问展厅监听页面时，每个3s轮询上报访问状态。
   * 接口地址：http://doc.phonebus.corpautohome.com/project/900/interface/api/22343
   * _appId  业务方名称
   * dealerIds 经销商id,
   * userId 用户Id
   * timestamp 时间戳
   * @returns
   */
  getServiceAdvisor(params) {
    const { dealerId, userId, timestamp, ext } = params;
    return request({
      type: 'post',
      xhrFields: { withCredentials: true },
      url: config.vrtake + urls.getServiceAdvisor + '?_appid=' + appId,
      data: JSON.stringify({
        dealerId,
        userId,
        timestamp,
        ext: ext,
      }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/23363
   * 获取vr带看顾问设置
   * @param {*} dealerId 经销商ID
   * @param {*} encryptedInfo 加密信息
   * @returns
   */
  getSaleVrSetting(dealerId, encryptedInfo = '') {
    return request({
      type: 'get',
      url: config.vrtake + urls.vrSaleSetting,
      data: {
        dealerId,
        encryptedInfo,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse: function (data) {
        if (data && data.returncode === 0 && data.result) {
          return { returncode: 0, message: data.message, result: data };
        } else {
          return { returncode: 1, message: '获取vr带看顾问设置', result: data };
        }
      },
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/30650
   * 根据明文或密文saleId（选择一个必传）获取顾问信息
   * @param {*} saleId 顾问ID
   * @param {*} encryptedInfo 加密信息
   * @returns
   */
  getSalesById(saleId, encryptedInfo = '') {
    return request({
      type: 'get',
      url: config.vrtake + urls.getSalesById,
      data: {
        saleId,
        encryptedInfo,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
      transformResponse: function (data) {
        if (data && data.returncode === 0 && data.result) {
          return { returncode: 0, message: data.message, result: data };
        } else {
          return { returncode: 1, message: '获取顾问信息', result: data };
        }
      },
    });
  },
  /**
   * 经销商ID-获取待分配顾问列表
   *  http://doc.phonebus.corpautohome.com/project/900/interface/api/36225
   *  @20220715
   */
  getSalesBydealerId(dealerId) {
    return request({
      type: 'get',
      url: config.vrtake + '/api/sales/match/dealer/all',
      data: {
        dealerId,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
    });
  },
  /**
   *  呼叫中等待时客户诉求上报查询（B端用）
   *  http://doc.phonebus.corpautohome.com/project/900/interface/api/36423
   *  @20220715
   *  @params
   *    channelId string
   *    channelName 语音频道名称：加密(String)
   */
  getAppeal(channelName, channelId) {
    return request({
      type: 'get',
      url: config.vrtake + '/api/channel/v1/customer/appeal/query',
      data: {
        channelName,
        channelId,
        _appId: appId,
      },
      contentType: 'application/json;charset=utf-8',
    });
  },
  /**
   *  呼叫中等待时客户诉求上报
   *  http://doc.phonebus.corpautohome.com/project/900/interface/api/36417
   * 入参DEMO：
   * {
   *     "seriesId": 18,
   *     "seriesName": "奥迪A8L",
   *     "appeal": ["SERIES", "BUY_CAR"], 客户诉求对象: SERIES-车系信息;BUY_CAR-购车政策;DEALER_ACTIVITY-店内活动;EXISTING_CAR-是否有现车;
   *     "channelId": "994193757316411392"
   * }
   * @20220715
   */
  createAppeal(appealData) {
    return request({
      type: 'post',
      url: config.vrtake + '/api/channel/v1/customer/appeal?_appid=' + appId,
      data: JSON.stringify(appealData),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },

  /**
   *  获取使用Vr带看功能，接通的channel量
   *  http://doc.phonebus.corpautohome.com/project/900/interface/api/38363
   *  @20220908
   * @returns
   */

  getStatUvCount() {
    return request({
      type: 'post',
      url: config.vrtake + '/api/stat/uv',
      data: JSON.stringify({ _appId: this.appId }),
      contentType: 'application/json;charset=utf-8',
      transformResponse,
    });
  },
};
